import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { getToken, removeToken } from "../api/auth";
import { useSiteLogo } from "../api/siteLogo";

function Header() {
  const token = getToken();
  const logo = useSiteLogo();
  const navigate = useNavigate();
  const location = useLocation();
  const [dark, setDark] = useState(
    () => document.documentElement.getAttribute("data-theme") === "dark"
  );

  const handleLogout = () => {
    removeToken();
    navigate("/login", { replace: true });
  };

  const toggleTheme = () => {
    const next = !dark;
    setDark(next);
    document.documentElement.setAttribute("data-theme", next ? "dark" : "light");
    localStorage.setItem("kademy-theme", next ? "dark" : "light");
  };

  const itemClass = (path) =>
    `nav-link${location.pathname === path ? " active" : ""}`;

  const closeMenu = () => {
    const menu = document.getElementById("offcanvasNavbar");
    if (!menu?.classList.contains("show")) return;
    const Offcanvas = window.bootstrap?.Offcanvas;
    if (Offcanvas) Offcanvas.getOrCreateInstance(menu).hide();
  };

  return (
    <header className="header">
      <div className="main-navigation">
        <nav className="navbar navbar-expand-lg">
          <div className="container position-relative">
            <Link className="navbar-brand" to="/">
              <img className="header-logo" src={logo} alt="Kademy" />
            </Link>

            <div className="mobile-menu-right">
              <button
                type="button"
                className="theme-toggle"
                aria-pressed={dark}
                aria-label={dark ? "Switch to light mode" : "Switch to dark mode"}
                onClick={toggleTheme}
              >
                <i className={dark ? "fas fa-sun" : "fas fa-moon"} aria-hidden="true"></i>
              </button>
              <button
                className="navbar-toggler"
                type="button"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasNavbar"
                aria-label="Open menu"
              >
                <span></span>
                <span></span>
                <span></span>
              </button>
            </div>

            <div className="offcanvas offcanvas-start" id="offcanvasNavbar">
              <div className="offcanvas-header">
                <Link to="/" className="offcanvas-brand" onClick={closeMenu}>
                  <img src={logo} alt="Kademy" />
                </Link>
                <button className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close menu">
                  <i className="far fa-xmark"></i>
                </button>
              </div>

              <div className="offcanvas-body gap-xl-4">
                <ul className="navbar-nav justify-content-end flex-grow-1">
                  <li className="nav-item">
                    <Link className={itemClass("/")} to="/" onClick={closeMenu}>
                      Home
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className={`nav-link${
                        location.pathname === "/courses" ||
                        location.pathname.startsWith("/courses/")
                          ? " active"
                          : ""
                      }`}
                      to="/courses"
                      onClick={closeMenu}
                    >
                      Courses
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className={itemClass("/pricing")} to="/pricing" onClick={closeMenu}>
                      Pricing
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className={itemClass("/blog")} to="/blog" onClick={closeMenu}>
                      Blog
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className={`nav-link${
                        location.pathname.startsWith("/current-affairs") ? " active" : ""
                      }`}
                      to="/current-affairs"
                      onClick={closeMenu}
                    >
                      Current Affairs
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className={`nav-link${
                        location.pathname.startsWith("/exam-notes") ? " active" : ""
                      }`}
                      to="/exam-notes"
                      onClick={closeMenu}
                    >
                      Exam wise notes
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className={itemClass("/contact")} to="/contact" onClick={closeMenu}>
                      Contact
                    </Link>
                  </li>
                  {token && (
                    <li className="nav-item">
                      <Link
                        className={`nav-link${
                          location.pathname === "/dashboard" ||
                          location.pathname.startsWith("/my-courses")
                            ? " active"
                            : ""
                        }`}
                        to="/dashboard"
                        onClick={closeMenu}
                      >
                        Dashboard
                      </Link>
                    </li>
                  )}
                </ul>

                <div className="nav-actions">
                  <button
                    type="button"
                    className="theme-toggle theme-toggle-desktop"
                    aria-pressed={dark}
                    aria-label={dark ? "Switch to light mode" : "Switch to dark mode"}
                    onClick={toggleTheme}
                  >
                    <i className={dark ? "fas fa-sun" : "fas fa-moon"} aria-hidden="true"></i>
                  </button>

                  {!token ? (
                    <>
                      <Link to="/login" className="nav-login" onClick={closeMenu}>
                        Login
                      </Link>
                      <Link to="/register" className="btn-accent" onClick={closeMenu}>
                        Sign Up
                      </Link>
                    </>
                  ) : (
                    <button type="button" onClick={handleLogout} className="nav-login">
                      Logout
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </header>
  );
}

export default Header;
